import { useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import { ModalContainer } from './components/Modal';

import { Toaster } from 'react-hot-toast';
import { isMobile, toastContainerStyle, toastOptions } from './utils/util';

import { useAppDispatch } from './hooks/useRedux';
import { modalRemoveAll } from './features/modalSlice';

if (isMobile) {
  document.body.classList.add('is--mobile');
}

function App() {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(modalRemoveAll());
  }, []);

  return (
    <>
      <Outlet />
      <ModalContainer />
      <Toaster
        toastOptions={toastOptions}
        containerStyle={toastContainerStyle}
      />
    </>
  );
}

export default App;
